import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Issue22025() {
  const handleDownload1 = () => {
    window.open(
      "assets/2025/issue2/1. What drives rice production in Manipur. A Decomposition Analysis -- Samsur Jaman , K. Sunindro Singh , Damodar Nepram.pdf",
      "_blank",
    );
  };
  const handleDownload2 = () => {
    window.open(
      "assets/2025/issue2/2. Fish production of Mizoram and Import Dependency Over Time --- James LT Thanga  and Esther Vanlalhruaii.pdf",
      "_blank",
    );
  };
  const handleDownload3 = () => {
    window.open(
      "assets/2025/issue2/3. Levels of Farmers' Condition in Agricultural Development Indicators, Mizoram -- Lalmalsawmi Renthlei  & Giribabu M.pdf",
      "_blank",
    );
  };
  const handleDownload4 = () => {
    window.open(
      "assets/2025/issue2/4. Challenges and Opportunities in Teaching-Learning Economics at Under-Graduate Level in Mizoram -- Lalfakawmi.pdf",
      "_blank",
    );
  };
  const handleDownload5 = () => {
    window.open(
      "assets/2025/issue2/5. Economic Analysis of Public Healthcare System in Mizoram - Lalrinkima.pdf",
      "_blank",
    );
  };
  const handleDownload6 = () => {
    window.open(
      "assets/2025/issue2/6. Role of Rural Agricultural & Non-Agricultural Sector --M.S. Dawngliana Hnamte .pdf",
      "_blank",
    );
  };
  const handleDownload7 = () => {
    window.open(
      "assets/2025/issue2/7. An Analysis of State Own Tax Revenue in Mizoram with Special Reference to Dawrpui Vengthar -- Lalrinthanga.pdf",
      "_blank",
    );
  };
  const handleDownload8 = () => {
    window.open(
      "assets/2025/issue2/8. Statistics At a Glance - Area and Production of Major Agricultural Crops in Mizoram.pdf",
      "_blank",
    );
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <meta
        name="description"
        content="What drives rice production in Manipur. A Decomposition Analysis"
      />
      <meta
        name="description"
        content="Fish production of Mizoram and Import Dependency Over Time"
      />
      <meta
        name="description"
        content="Levels of Farmers' Condition in Agricultural Development Indicators, Mizoram"
      />
      <meta
        name="description"
        content="Challenges and Opportunities in Teaching-Learning Economics at Under-Graduate Level in Mizoram"
      />
      <meta
        name="description"
        content="Economic Analysis of Public Healthcare System in Mizoram"
      />
      <meta
        name="description"
        content="Role of Rural Agricultural & Non-Agricultural Sector"
      />
      <meta
        name="description"
        content="An Analysis of State Own Tax Revenue in Mizoram with Special Reference to Dawrpui Vengthar"
      />
      <meta
        name="description"
        content="Statistics At a Glance - Area and Production of Major Agricultural Crops in Mizoram"
      />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume VIII, Issue 2, December 2025</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  What drives rice production in Manipur. A Decomposition Analysis
                </div>
                <div className="text-sm text-green-600">
                  Samsur Jaman , K. Sunindro Singh , Damodar Nepram
                </div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Fish production of Mizoram and Import Dependency Over Time
                </div>
                <div className="text-sm text-green-600">
                  James LT Thanga  and Esther Vanlalhruaii
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Levels of Farmers' Condition in Agricultural Development Indicators, Mizoram
                </div>
                <div className="text-sm text-green-600">Lalmalsawmi Renthlei  & Giribabu M</div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Challenges and Opportunities in Teaching-Learning Economics at Under-Graduate Level in Mizoram
                </div>
                <div className="text-sm text-green-600">Lalfakawmi</div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 Economic Analysis of Public Healthcare System in Mizoram
                </div>
                <div className="text-sm text-green-600">
                  Lalrinkima
                </div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 Role of Rural Agricultural & Non-Agricultural Sector
                </div>
                <div className="text-sm text-green-600">M.S. Dawngliana Hnamte</div>
              </button>
              <button className="text-left" onClick={handleDownload7}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 An Analysis of State Own Tax Revenue in Mizoram with Special Reference to Dawrpui Vengthar
                </div>
                <div className="text-sm text-green-600">
                  Lalrinthanga
                </div>
              </button>
              <button className="text-left" onClick={handleDownload8}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  STATISTICS AT A GLANCE
                </div>
                <div className="text-sm text-green-600">
                  Area and Production of Major Agricultural Crops in Mizoram
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
